module.exports = __webpack_public_path__ + "static/media/HN.7168d67f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/HN.svg
// module id = 270
// module chunks = 0